import React, { useEffect, useState } from 'react'
import {
    CCard,
    CCardHeader,
    CCardBody,
    CCardText,
    CTable,
    CTableBody,
    CTableRow,
    CTableDataCell,
    CRow,
    CCol,
    CFormSelect,
} from '@coreui/react'

import CookieFunctions from '../../functions/CookieFunctions';
import { timeOffNames } from '../../Constants';

export default function Summary({ summary, setType }) {
    const driverType = CookieFunctions.getDriverType();
    const country = CookieFunctions.getCountry();
    const [selectedType, setSelectedType] = useState('TOVAC');  // Default initial type is 'TOVAC'

    useEffect(() => {
        setType('TOVAC');  // Set initial type to 'TOVAC' when the component mounts
    }, [setType]);

    const handleTypeChange = (e) => {
        const type = e.target.value;
        setSelectedType(type);  // Save the selected type
        setType(type);  // Update the parent component's state
    };

    return (
        <CCard style={{ marginBottom: '1rem' }}>
            <CCardHeader>Summary</CCardHeader>
            <CCardBody>
                <CRow>
                    <CCol sm="12" className='my-2'>
                        <CCardText className='fs-4'>Time Off Type</CCardText>
                    </CCol>
                    <CCol sm="4" className='my-2'>
                        <CFormSelect onChange={handleTypeChange}>
                            {Object.keys(timeOffNames[driverType][country])
                                .filter(x => !(driverType === "CO" && country === "CAN" && x === "TOUNP"))
                                .map((x, i) => {
                                    return <option key={i} value={x}>{timeOffNames[driverType][country][x]}</option>
                                })}
                        </CFormSelect>
                    </CCol>
                </CRow>
                <hr />
                <CRow>
                    <CCol sm={12} md={6}>
                        <CCardText className='fs-4'>Current Balance</CCardText>
                        <CCardText className='fs-1' style={{ fontWeight: '500' }}>{summary ? `${summary.balance} Days${selectedType === 'TOVAC' && summary.statWorkedCount > 0 ? ` (Including ${summary.statWorkedCount} In Lieu) ` : ''}` : null}</CCardText>
                        <CTable borderless>
                            <CTableBody>
                                <CTableRow>
                                    <CTableDataCell className='fs-4'>Requested: </CTableDataCell>
                                    <CTableDataCell className='fs-4' style={{ textAlign: 'right' }}>{summary ? summary.requested : null}</CTableDataCell>
                                    <CTableDataCell className='fs-4'>Day(s)</CTableDataCell>
                                </CTableRow>
                                <CTableRow>
                                    <CTableDataCell className='fs-4' >Planned: </CTableDataCell>
                                    <CTableDataCell className='fs-4' style={{ textAlign: 'right' }}>{summary ? summary.planned : null}</CTableDataCell>
                                    <CTableDataCell className='fs-4' >Day(s)</CTableDataCell>
                                </CTableRow>
                                <CTableRow style={{ borderBottomWidth: '2px' }}>
                                    <CTableDataCell className='fs-4'>Used: </CTableDataCell>
                                    <CTableDataCell className='fs-4' style={{ textAlign: 'right' }}>{summary ? summary.used : null}</CTableDataCell>
                                    <CTableDataCell className='fs-4' >Day(s)</CTableDataCell>
                                </CTableRow>
                                <CTableRow>
                                    <CTableDataCell className='fs-4'>End of Year Balance: </CTableDataCell>
                                    <CTableDataCell className='fs-4' style={{ textAlign: 'right' }}>{summary ? summary.total : null}</CTableDataCell>
                                    <CTableDataCell className='fs-4' >Day(s)</CTableDataCell>
                                </CTableRow>
                            </CTableBody>
                        </CTable>
                    </CCol>
                    <CCol sm={12} md={6} style={{ display: 'flex' }}>
                        <CCardText style={{ display: 'grid', justifyContent: 'center' }}>
                            <p><b>Current Balance:</b> {country === 'CAN' ? 'Includes total number of days plus statutory holiday worked lieu days' : 'Total number of days you have accrued to book this year.'}<br /></p>
                            <p><b>Requested:</b> Total number of days currently requested and waiting for team leader to approve or reject<br /></p>
                            <p><b>Planned:</b> Total upcoming booked days off this year<br /></p>
                            <p><b>Used:</b> Total number of days that have been taken off this year<br /></p>
                            <p><b>End of Year Balance:</b> Total number of days able to book off for the year<br /></p>
                        </CCardText>
                    </CCol>
                </CRow>

            </CCardBody>
            {/* <CCardFooter className="text-medium-emphasis">2 days ago</CCardFooter> */}
        </CCard >)
}